import { gql } from "@apollo/client";

export const SAVE_INSTRUCTION_MUTATION = gql`
  mutation SaveInstruction($input: SaveInstructionInput!) {
    saveInstruction(input: $input) {
      totalProcessed
      totalSuccessful
      totalFailed
    }
  }
`;

export const VALIDATION_COVERAGE_MUTATION = gql`
  mutation ValidationCoverage($input: ValidationCoverageInput!) {
    validationCoverage(input: $input) {
      coverage
      information
      prompt
      success
      message
    }
  }
`;

export const DOCUMENT_CHAT_HISTORY_MUTATION = gql`
  mutation DocumentChatHistory($input: DocumentChatHistoryInput!) {
    documentChatHistory(input: $input) {
      messages {
        role
        message
      }
      sessionId
      success
      message
    }
  }
`;

export const DOCUMENT_ASSISTANT_MUTATION = gql`
  mutation DocumentAssistant($input: DocumentAssistantInput!) {
    documentAssistant(input: $input) {
      data
         success
        message
        sessionId
        refresh
    }
  }
`;

export const REMOVE_DOCUMENT_HISTORY_MUTATION = gql`
  mutation RemoveDocumentHistory($input: RemoveDocumentHistoryInput!) {
    removeDocumentHistory(input: $input) {
      success
      message
    }
  }
`;

// FAQs Mutations

export const GENERATE_UPLOAD_URL_MUTATION = gql`
  mutation GenerateUploadUrl($input: GenerateUploadUrlInput!) {
    generateUploadUrl(input: $input) {
      uploadUrl
      fileKey
      fileId
    }
  }
`;

// Generate Document (AI) Mutation

export const GENERATE_DOCUMENT_MUTATION = gql`
    mutation GenerateDocument($input: GenerateDocumentInput!) {
        generateDocument(input: $input) {
            content
            provider
            model
            tokensUsed
        }
    }
`;

// Create Product Maintenance Schedule Mutation
